import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "../../api/axios";
import Receipt from './receipt';

const TABLE_URL = "/api/table";
const PRODUCTS_URL = '/api/product';
const EARNINGS_URL = '/api/earnings/subtract';
const BACK_END_URL = "https://shtato-b15797a0a9a3.herokuapp.com/";

function Command() {
    const [table, setTable] = useState(null);
    const [tableItems, setTableItems] = useState([]);
    const { id } = useParams();
    const [products, setProducts] = useState([]);
    const [selectedType, setSelectedType] = useState("food");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [paymentType, setPaymentType] = useState('');
    const [splitCount, setSplitCount] = useState(1);
    const [showSplitModal, setShowSplitModal] = useState(false);
    const [splitItems, setSplitItems] = useState([]);
    const [currentSplitIndex, setCurrentSplitIndex] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [showMergeModal, setShowMergeModal] = useState(false);
    const [selectedTables, setSelectedTables] = useState([]);
    const [availableTables, setAvailableTables] = useState([]);
    const [discountModal, setDiscountModal] = useState(false);
    const [discountPassword, setDiscountPassword] = useState("");
    const [passwordVerified, setPasswordVerified] = useState(false);
    const [passwordError, setPasswordError] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState(() => {
        const savedNumber = localStorage.getItem('invoiceNumber');
        return savedNumber ? parseInt(savedNumber, 10) : 1;
    });

    useEffect(() => {
        localStorage.setItem('invoiceNumber', invoiceNumber);
    }, [invoiceNumber]);

    const handleInvoiceSuccess = () => {
        setInvoiceNumber(prev => {
            const newNumber = prev + 1;
            return newNumber > 9 ? newNumber : newNumber;
        });
    };

    const toggleDiscount = async () => {
        setDiscountModal(!discountModal);
        if (!discountModal) {
            setPasswordVerified(false);
            setDiscountPassword("");
            setPasswordError("");
        }
    }

    const verifyPassword = () => {
        if (discountPassword === "0000") {
            setPasswordVerified(true);
            setPasswordError("");
        } else {
            setPasswordError("Incorrect password. Please try again.");
        }
    }

    const applyDiscount = () => {
        toggleDiscount();
    }

    const fetchTables = async () => {
        try {
            const response = await axios.get(`${TABLE_URL}`);
            setAvailableTables(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    const mergeTables = async () => {
        try {
            const originalItems = [...tableItems];
            const mergedItems = [...tableItems];

            for (const tableId of selectedTables) {
                const response = await axios.get(`${TABLE_URL}/${tableId}`);
                const tableToMerge = response.data;

                tableToMerge.tableItems?.forEach(item => {
                    const existingItemIndex = mergedItems.findIndex(i => i._id === item._id);
                    if (existingItemIndex !== -1) {
                        mergedItems[existingItemIndex].quantity += (item.quantity || 1);
                    } else {
                        mergedItems.push({ ...item, quantity: item.quantity || 1 });
                    }
                });

                await axios.patch(`${TABLE_URL}/merge-clean/${tableId}`);
            }

            await axios.patch(`${TABLE_URL}/merge/${id}`, {
                items: mergedItems,
                oldItems: originalItems
            });

            setTableItems(mergedItems);
            setSelectedTables([]);
            setShowMergeModal(false);

        } catch (error) {
            console.error("Error merging tables:", error);
            alert("Failed to merge tables");
        }
    };

    const typeCategories = {
        food: [
            "SALAD", "BURGER", "SANDWICH", "OMELETTE", "PLATS", "HARIRA", "TAGINE", "COUSCOUS", "DESSERTS"
        ],
        drinks: ["COFFEE", "JUICE", "MOCKTAILS", "TEA", "WATERS", "BEER"]
    };

    useEffect(() => {
        fetchProducts();
        fetchTable();
        fetchTables();
    }, [id]);

    useEffect(() => {
        if (splitCount > 1) {
            const initialSplitItems = Array(splitCount).fill().map(() => []);
            setSplitItems(initialSplitItems);
        }
    }, [splitCount]);

    const fetchProducts = async () => {
        try {
            const response = await axios.get(PRODUCTS_URL);
            setProducts(response?.data);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchTable = async () => {
        try {
            const response = await axios.get(`${TABLE_URL}/${id}`);
            setTable(response.data);
            setTableItems(response.data.tableItems?.map(item => ({
                ...item,
                quantity: item.quantity || 1
            })) || []);
        } catch (error) {
            console.error("Error fetching table:", error);
            alert("Failed to fetch table details");
        }
    };

    const addItemToTable = async (item) => {
        const oldItems = [...tableItems];

        let updatedItems;
        const existingItem = tableItems.find(i => i._id === item._id);

        if (existingItem) {
            updatedItems = tableItems.map(i =>
                i._id === item._id ? { ...i, quantity: i.quantity + 1 } : i
            );
        } else {
            updatedItems = [...tableItems, { ...item, quantity: 1 }];
        }

        setTableItems(updatedItems);

        try {
            await axios.patch(`${TABLE_URL}/add/${id}`, {
                items: updatedItems,
                oldItems: oldItems,
                reserver: true
            });

            setTable({ ...table, reserver: true });
        } catch (error) {
            console.error("Error updating table:", error);
            setTableItems(oldItems);
        }
    };

    const updateItemQuantity = async (itemId, change) => {
        const oldItems = [...tableItems];
        console.log(oldItems);


        try {
            let updatedItems = tableItems.map(item => {
                if (item._id === itemId) {
                    const newQuantity = Math.max(0, (item.quantity || 1) + change);
                    return newQuantity === 0 ? null : { ...item, quantity: newQuantity };
                }
                return item;
            }).filter(Boolean);

            setTableItems(updatedItems);

            const response = await axios.patch(`${TABLE_URL}/add/${id}`, {
                items: updatedItems,
                oldItems: oldItems
            });

            setTable({ ...table, reserver: updatedItems.length > 0 });

        } catch (error) {
            console.error("Error updating quantity:", error);
            setTableItems(oldItems);
        }
    };

    const cleanTable = async () => {
        try {
            await axios.patch(`${TABLE_URL}/clean/${id}`);
            setTableItems([]);
            setTable({ ...table, reserver: false });
            takeDiscount(discount)
        } catch (error) {
            console.error("Error cleaning table:", error);
            alert("Failed to clean the table");
        }
    };

    const toggleReservation = async () => {
        try {
            const newStatus = !table.reserver;

            const response = await axios.patch(`${TABLE_URL}/reserve/${id}`, { reserver: newStatus });

            if (response.status === 200) {
                setTable(prevTable => ({ ...prevTable, reserver: newStatus }));
            }
        } catch (error) {
            console.error("Error updating table reservation:", error);
            alert("Failed to update reservation. Please try again.");
        }
    };

    const takeDiscount = async (discount) => {
        try {
            const response = await axios.put(EARNINGS_URL, {
                amount: Number(discount),
            });

        } catch (err) {
            console.error('Error deducting earnings:', err);
        }
    };

    const calculateTotal = () => {
        const subtotal = tableItems.reduce((sum, item) =>
            sum + (item.price * (item.quantity || 1)), 0
        );
        return Math.max(0, subtotal - discount);
    };

    const calculateSplitTotal = (splitIndex) => {
        if (!splitItems[splitIndex]) return 0;
        const subtotal = splitItems[splitIndex].reduce((sum, item) =>
            sum + (item.price * (item.quantity || 1)), 0
        );
        const discountAmount = (subtotal * discount) / 100;
        return subtotal - discountAmount;
    };

    const handleTypeChange = (type) => {
        setSelectedType(type);
        setSelectedCategory("");
    };

    const filteredProducts = products.filter(product => {
        if (!selectedType) return true;
        if (!selectedCategory) {
            return typeCategories[selectedType].includes(product.category);
        }
        return product.category === selectedCategory;
    });

    const startSplitBill = () => {
        if (splitCount <= 1) return;

        const initialSplitItems = Array(splitCount).fill().map(() => []);
        setSplitItems(initialSplitItems);
        setCurrentSplitIndex(0);
        setShowSplitModal(true);
    };

    const addItemToSplit = (item) => {
        const originalItem = tableItems.find(i => i._id === item._id);
        if (!originalItem) return;

        const totalAssignedQuantity = splitItems.reduce((sum, billItems) => {
            const assignedItem = billItems.find(i => i._id === item._id);
            return sum + (assignedItem ? assignedItem.quantity : 0);
        }, 0);

        console.log('Original total quantity:', originalItem.quantity);
        console.log('Assigned quantity:', totalAssignedQuantity);

        if (totalAssignedQuantity + 1 > originalItem.quantity) {
            alert("All quantities of this item have already been assigned to bills");
            return;
        }

        const updatedSplitItems = [...splitItems];
        const existingItemIndex = updatedSplitItems[currentSplitIndex].findIndex(i => i._id === item._id);

        if (existingItemIndex !== -1) {
            updatedSplitItems[currentSplitIndex][existingItemIndex].quantity += 1;
        } else {
            updatedSplitItems[currentSplitIndex].push({ ...originalItem, quantity: 1 });
        }

        setSplitItems(updatedSplitItems);
    };

    const moveToNextSplit = () => {
        if (currentSplitIndex < splitCount - 1) {
            setCurrentSplitIndex(currentSplitIndex + 1);
        } else {
            setShowSplitModal(false);
        }
    };

    // In your command component
    const handlePrint = () => {
        // First prepare the printer
        const originalTitle = document.title;
        document.title = "Receipt #" + invoiceNumber;

        // Set printer-specific settings
        const style = document.createElement('style');
        style.id = 'printer-settings';
        style.textContent = `
        @page {
            size: 80mm auto !important;
            margin: 0mm !important;
        }
    `;
        document.head.appendChild(style);

        // Print the document
        window.print();

        // Clean up
        document.head.removeChild(style);
        document.title = originalTitle;

        // Update invoice number after printing
        handleInvoiceSuccess();
    };
    const getRemainingItems = () => {
        const itemsWithRemainingQuantity = tableItems.map(item => {
            const assignedQuantity = splitItems.reduce((sum, billItems) => {
                const assignedItem = billItems.find(i => i._id === item._id);
                return sum + (assignedItem ? assignedItem.quantity : 0);
            }, 0);

            const remainingQuantity = item.quantity - assignedQuantity;
            return { ...item, quantity: remainingQuantity };
        }).filter(item => item.quantity > 0);

        return itemsWithRemainingQuantity;
    };

    if (!table) return <p>Loading...</p>;

    return (
        <div className="flex gap-4">
            <div className="w-full max-w-md bg-gradient-to-b from-white to-gray-50/50 rounded-3xl shadow-xl border border-gray-100 backdrop-blur-sm">
                <div className="sticky top-4">
                    <div className="p-8">
                        <div className="relative mb-8">
                            <div className="flex gap-2">
                                <button
                                    onClick={tableItems.length > 0 ? cleanTable : toggleReservation}
                                    className={`px-5 py-2.5 rounded-2xl text-sm font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 ${tableItems.length > 0
                                        ? "bg-gradient-to-r from-violet-600 to-indigo-600 text-white"
                                        : table.reserver
                                            ? "bg-gradient-to-r from-green-600 to-emerald-600 text-white"
                                            : "bg-gradient-to-r from-gray-900 to-gray-800 text-white"
                                        }`}
                                >
                                    {tableItems.length > 0 ? "Clean Table" :
                                        table.reserver ? "Free Table" : "Reserve Table"}
                                </button>

                                <button
                                    onClick={() => {
                                        setShowMergeModal(true);
                                        fetchTables();
                                    }}
                                    className="px-5 py-2.5 rounded-2xl text-sm font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 bg-gradient-to-r from-orange-600 to-red-600 text-white"
                                >
                                    Merge Tables
                                </button>
                            </div>
                        </div>

                        <div className="space-y-6">
                            <div className="flex items-center justify-between">
                                <h2 className="text-2xl font-bold text-gray-900">Order Details</h2>
                                <span className="px-4 py-1 text-sm font-medium text-indigo-600 bg-indigo-50 rounded-full ring-1 ring-indigo-100">
                                    {tableItems.length} items
                                </span>
                            </div>

                            <div className="max-h-[calc(100vh-400px)] overflow-y-auto space-y-4 pr-2">
                                {tableItems.map((item, index) => (
                                    <div key={index}
                                        className="group p-4 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 hover:border-indigo-100">
                                        <div className="flex justify-between items-center">
                                            <div className="space-y-1">
                                                <h3 className="font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors">
                                                    {item.name}
                                                </h3>
                                                <p className="text-gray-600">{item.price} DH</p>
                                            </div>
                                            <div className="flex items-center gap-2 bg-gray-50 px-2 py-1 rounded-xl shadow-sm">
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        updateItemQuantity(item._id, -1);
                                                    }}
                                                    className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all"
                                                >
                                                    −
                                                </button>
                                                <span className="w-8 text-center font-semibold text-gray-900">
                                                    {item.quantity || 1}
                                                </span>
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        updateItemQuantity(item._id, 1);
                                                    }}
                                                    className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="pt-6 mt-6 border-t border-gray-100">
                                <div className="space-y-6">
                                    <div className="grid grid-cols-2 gap-6">
                                        <div className="space-y-3">
                                            <label className="block text-sm font-semibold text-gray-900">
                                                Payment Method
                                            </label>
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={() => setPaymentType('cash')}
                                                    className={`flex-1 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 ${paymentType === 'cash'
                                                        ? 'bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-lg hover:shadow-xl'
                                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                                        }`}
                                                >
                                                    Espèce
                                                </button>
                                                <button
                                                    onClick={() => setPaymentType('card')}
                                                    className={`flex-1 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 ${paymentType === 'card'
                                                        ? 'bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-lg hover:shadow-xl'
                                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                                        }`}
                                                >
                                                    Carte
                                                </button>
                                            </div>
                                        </div>

                                        <div className="space-y-3">
                                            <label className="block text-sm font-semibold text-gray-900">
                                                Split Bill
                                            </label>
                                            <div className="flex items-center bg-gray-50 rounded-xl shadow-sm border border-gray-200">
                                                <button
                                                    onClick={() => setSplitCount(Math.max(1, splitCount - 1))}
                                                    className="w-12 h-12 flex items-center justify-center text-gray-600 hover:text-indigo-600 hover:bg-gray-100 rounded-l-xl transition-all"
                                                >
                                                    −
                                                </button>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    value={splitCount}
                                                    onChange={(e) => setSplitCount(Math.max(1, Number(e.target.value)))}
                                                    className="w-16 text-center text-gray-900 font-semibold bg-transparent focus:outline-none"
                                                />
                                                <button
                                                    onClick={() => setSplitCount(splitCount + 1)}
                                                    className="w-12 h-12 flex items-center justify-center text-gray-600 hover:text-indigo-600 hover:bg-gray-100 rounded-r-xl transition-all"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-3">
                                        <div className="flex justify-between items-center bg-gradient-to-r from-indigo-50 to-violet-50 p-6 rounded-2xl shadow-sm">
                                            <span className="text-lg font-semibold text-gray-900">Total Amount</span>
                                            <span className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
                                                {calculateTotal().toFixed(2)} DH
                                            </span>
                                        </div>

                                        <div className="flex justify-center">
                                            <div className="inline-block rounded-full border-2 border-[#610c63] px-6 pb-[6px] pt-2 text-xs font-medium uppercase leading-normal text-[#610c63] transition duration-150 ease-in-out hover:border-[#4a0a4c] hover:bg-[#610c63]/10 hover:text-[#4a0a4c] focus:border-[#4a0a4c] focus:bg-[#610c63]/10 focus:text-[#4a0a4c] focus:outline-none focus:ring-0 active:border-[#380839] active:text-[#380839] motion-reduce:transition-none">
                                                <button onClick={toggleDiscount} className="w-full h-full text-left">
                                                    <span className="font-semibold">Apply Discount</span>
                                                </button>
                                            </div>
                                        </div>

                                        {splitCount > 1 && (
                                            <div>
                                                <button
                                                    onClick={startSplitBill}
                                                    className="w-full mt-4 px-6 py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl text-sm font-semibold transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 focus:outline-none"
                                                >
                                                    Select Items for Each Bill
                                                </button>

                                                {splitItems.some(items => items.length > 0) && (
                                                    <div className="mt-4 space-y-3">
                                                        {splitItems.map((items, index) => (
                                                            <div key={index} className="flex justify-between items-center bg-gray-50 p-4 rounded-xl">
                                                                <span className="text-gray-600 font-medium">Bill {index + 1} ({items.length} items)</span>
                                                                <span className="font-semibold text-indigo-600">
                                                                    {calculateSplitTotal(index).toFixed(2)} DH
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                </div>

                                {tableItems.length > 0 && (
                                    <button
                                        onClick={handlePrint}
                                        className="w-full mt-8 px-6 py-4 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-2xl text-sm font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        Print Receipt
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!showSplitModal ? (
                <div className="w-2/3">
                    <div className="bg-white rounded-2xl p-4 shadow-lg border border-gray-200">
                        <div className="mb-6 flex justify-center space-x-4">
                            {['food', 'drinks'].map((type) => (
                                <button
                                    key={type}
                                    onClick={() => handleTypeChange(type)}
                                    className={`px-8 py-3 rounded-lg text-lg font-semibold transition duration-200 ${selectedType === type
                                        ? 'bg-[#4335A7] text-white shadow-lg'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                        }`}
                                >
                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                </button>
                            ))}
                        </div>

                        {selectedType && (
                            <div className="mb-8 flex flex-wrap justify-center gap-3">
                                <button
                                    onClick={() => setSelectedCategory("")}
                                    className={`px-4 py-2 rounded-lg text-sm font-medium transition duration-200 ${!selectedCategory
                                        ? 'bg-[#4335A7] text-white shadow-md'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                        }`}
                                >
                                    All {selectedType.charAt(0).toUpperCase() + selectedType.slice(1)}
                                </button>
                                {typeCategories[selectedType].map((category) => (
                                    <button
                                        key={category}
                                        onClick={() => setSelectedCategory(category)}
                                        className={`px-4 py-2 rounded-lg text-sm font-medium transition duration-200 ${selectedCategory === category
                                            ? 'bg-[#4335A7] text-white shadow-md'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                            }`}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                        )}

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {filteredProducts.map((product) => (
                                <div
                                    key={product._id}
                                    onClick={() => addItemToTable(product)}
                                    className="bg-white rounded-md border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200 transform hover:-translate-y-1 cursor-pointer"
                                >
                                    {product.logo && (
                                        <div className="w-full h-24 overflow-hidden bg-gray-100">
                                            <img
                                                src={`${BACK_END_URL}images/` + product.logo}
                                                alt={product.name}
                                                className="w-full h-full object-cover transition-transform duration-200"
                                            />
                                        </div>
                                    )}
                                    <div className="p-2">
                                        <h3 className="text-base font-semibold mb-1">
                                            {product.name}
                                        </h3>
                                        <div className="flex justify-between items-center">
                                            <span className="text-[#4335A7] font-bold text-base">
                                                {product.price.toFixed(2)} DH
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="w-2/3">
                    <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200">
                        <div className="text-center mb-6">
                            <h2 className="text-2xl font-bold text-gray-900">
                                Split Bill - Select Items for Bill {currentSplitIndex + 1}
                            </h2>
                            <p className="text-gray-600 mt-2">
                                Click on items to add them to this bill
                            </p>
                        </div>

                        <div className="grid grid-cols-2 gap-6 mb-8">
                            <div>
                                <h3 className="text-lg font-semibold mb-3 text-gray-900">
                                    Available Items
                                </h3>
                                <div className="bg-gray-50 p-4 rounded-xl space-y-4 max-h-96 overflow-y-auto">
                                    {getRemainingItems().map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() => addItemToSplit(item)}
                                            className="group p-4 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 hover:border-indigo-100 cursor-pointer"
                                        >
                                            <div className="flex justify-between items-center">
                                                <div className="space-y-1">
                                                    <h3 className="font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors">
                                                        {item.name}
                                                    </h3>
                                                    <p className="text-gray-600">{item.price} DH × {item.quantity}</p>
                                                </div>
                                                <div className="text-indigo-600 font-semibold">
                                                    {(item.price * item.quantity).toFixed(2)} DH
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {getRemainingItems().length === 0 && (
                                        <p className="text-gray-500 text-center py-8">
                                            All items have been assigned to bills
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div>
                                <h3 className="text-lg font-semibold mb-3 text-gray-900">
                                    Items in Bill {currentSplitIndex + 1}
                                </h3>
                                <div className="bg-gray-50 p-4 rounded-xl space-y-4 max-h-96 overflow-y-auto">
                                    {splitItems[currentSplitIndex]?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="p-4 bg-indigo-50 rounded-xl border border-indigo-100 shadow-sm"
                                        >
                                            <div className="flex justify-between items-center">
                                                <div className="space-y-1">
                                                    <h3 className="font-semibold text-indigo-800">
                                                        {item.name}
                                                    </h3>
                                                    <p className="text-indigo-600">{item.price} DH × {item.quantity}</p>
                                                </div>
                                                <div className="text-indigo-800 font-semibold">
                                                    {(item.price * item.quantity).toFixed(2)} DH
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {(!splitItems[currentSplitIndex] || splitItems[currentSplitIndex].length === 0) && (
                                        <p className="text-gray-500 text-center py-8">
                                            No items added to this bill yet
                                        </p>
                                    )}
                                </div>

                                <div className="mt-6 flex justify-between items-center bg-gradient-to-r from-indigo-50 to-violet-50 p-6 rounded-2xl shadow-sm">
                                    <span className="text-lg font-semibold text-gray-900">Bill {currentSplitIndex + 1} Total</span>
                                    <span className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
                                        {calculateSplitTotal(currentSplitIndex).toFixed(2)} DH
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-between items-center mt-8">
                            <button
                                onClick={() => setShowSplitModal(false)}
                                className="px-6 py-3 bg-gray-200 text-gray-800 rounded-xl text-sm font-semibold transition-all duration-300 hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={moveToNextSplit}
                                className="px-8 py-3 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-xl text-sm font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                            >
                                {currentSplitIndex < splitCount - 1 ?
                                    `Next (Bill ${currentSplitIndex + 2})` :
                                    'Finish Splitting'
                                }
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showMergeModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-6 max-w-2xl w-full mx-4">
                        <h2 className="text-2xl font-bold mb-4">Merge Tables</h2>
                        <p className="text-gray-600 mb-4">Select tables to merge with Table {table.tableNumber}</p>

                        <div className="grid grid-cols-3 gap-4 max-h-96 overflow-y-auto">
                            {availableTables.map((availableTable) => (
                                <div
                                    key={availableTable._id}
                                    onClick={() => {
                                        setSelectedTables(prev =>
                                            prev.includes(availableTable._id)
                                                ? prev.filter(id => id !== availableTable._id)
                                                : [...prev, availableTable._id]
                                        );
                                    }}
                                    className={`p-4 rounded-xl cursor-pointer transition-all duration-200 ${selectedTables.includes(availableTable._id)
                                        ? 'bg-indigo-100 border-2 border-indigo-500'
                                        : 'bg-gray-50 border-2 border-transparent hover:bg-gray-100'
                                        }`}
                                >
                                    <h3 className="font-semibold">Table {availableTable.tableNumber}</h3>
                                    <p className="text-sm text-gray-600">{availableTable.place}</p>
                                    <p className="text-sm text-gray-600">
                                        {availableTable.tableItems?.length || 0} items
                                    </p>
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-end gap-4 mt-6">
                            <button
                                onClick={() => {
                                    setShowMergeModal(false);
                                    setSelectedTables([]);
                                }}
                                className="px-6 py-2 rounded-xl bg-gray-100 text-gray-700 font-semibold hover:bg-gray-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={mergeTables}
                                disabled={selectedTables.length === 0}
                                className={`px-6 py-2 rounded-xl font-semibold ${selectedTables.length === 0
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-gradient-to-r from-indigo-600 to-violet-600 text-white hover:shadow-lg'
                                    }`}
                            >
                                Merge Selected Tables
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="invisible absolute">
                {splitCount <= 1 ? (
                    <Receipt
                        table={table}
                        tableItems={tableItems}
                        calculateTotal={calculateTotal}
                        splitCount={splitCount}
                        paymentType={paymentType}
                        invoiceNumber={invoiceNumber}
                    />
                ) : splitItems.map((items, index) => (
                    <div key={index}>
                        <Receipt
                            table={table}
                            tableItems={items}
                            calculateTotal={() => calculateSplitTotal(index)}
                            splitCount={1}
                            paymentType={paymentType}
                            billNumber={index + 1}
                            totalBills={splitCount}
                            discount={discount}
                            invoiceNumber={invoiceNumber}
                        />
                    </div>
                ))}
            </div>
            {discountModal && (
                <div
                    className="fixed inset-0 p-4 flex justify-center items-center w-full h-full z-[1000] overflow-auto font-sans"
                    style={{
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        backdropFilter: 'blur(5px)',
                        animation: 'fadeIn 0.3s ease-out'
                    }}
                >
                    <div
                        className="w-full max-w-md bg-white shadow-xl rounded-2xl p-8 relative"
                        style={{
                            animation: 'slideIn 0.3s ease-out',
                            boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)'
                        }}
                    >
                        <button
                            onClick={toggleDiscount}
                            className="absolute right-6 top-6 text-gray-400 hover:text-gray-600 hover:rotate-90 transition-all duration-300"
                            aria-label="Close"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="space-y-6">
                            <div className="text-center space-y-3">
                                <h4 className="text-2xl text-gray-900 font-medium tracking-tight">
                                    {!passwordVerified ? "Secure Access" : 'Apply Discount'}
                                </h4>
                                <p className="text-gray-500">
                                    {!passwordVerified
                                        ? "Enter the password to unlock discount options"
                                        : "Enter the discount percentage to apply to your order"}
                                </p>
                            </div>

                            {!passwordVerified ? (
                                <div className="space-y-5">
                                    <div className="relative">
                                        <input
                                            type="password"
                                            value={discountPassword}
                                            onChange={(e) => setDiscountPassword(e.target.value)}
                                            className="w-full px-5 py-4 border border-gray-200 rounded-xl text-center text-lg 
                          bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 
                          focus:border-transparent transition-all duration-300"
                                            placeholder="●●●●●●"
                                        />
                                        {passwordError && (
                                            <p className="text-red-500 text-sm mt-2 flex items-center justify-center">
                                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                {passwordError}
                                            </p>
                                        )}
                                    </div>
                                    <button
                                        onClick={verifyPassword}
                                        className="w-full px-6 py-4 bg-gray-900 text-white font-medium rounded-xl 
                      hover:bg-gray-800 transform hover:scale-[1.02] transition-all duration-300
                      focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                                    >
                                        Verify Password
                                    </button>
                                </div>
                            ) : (
                                <div className="space-y-5">
                                    <div className="relative">
                                        <div className="flex items-center">
                                            <input
                                                type="number"
                                                value={discount}
                                                min={1}
                                                onChange={(e) => setDiscount(e.target.value)}
                                                className="w-full px-5 py-4 border border-gray-200 rounded-xl text-center text-lg 
                            bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 
                            focus:border-transparent transition-all duration-300"
                                                placeholder="0"
                                            />
                                        </div>
                                    </div>
                                    <button
                                        onClick={toggleDiscount}
                                        className="w-full px-6 py-4 bg-gray-900 text-white font-medium rounded-xl
                      hover:bg-gray-800 transform hover:scale-[1.02] transition-all duration-300
                      focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                                    >
                                        Apply Discount
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Command;